/* eslint-disable eqeqeq */

export const CK_APP_VERSION = "v1.0.1";

export const IsEmpty = (obj) => {
  if (obj == null) return true;

  if (obj.length > 0) return false;
  if (obj.length === 0) return true;

  if (typeof obj !== "object") return true;

  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) return false;
  }

  return true;
};

export const getOrderItemStatusColorByStatusId = (statusId) => {
  let color = "black";

  switch (statusId) {
    case 2: // Confirmed
    case 8: // Delivered
      color = "green";
      break;
    case 3: // Cancelled
    case 13: // QA Failed
    case 14: // Disputed
    case 15: // Delivery Failed
    case 16: // Return
      color = "red";
      break;
    case 4: // Done Printing
      color = "blue";
      break;
    case 5: // In QA
    case 6: // Done QA
      color = "mediumorchid";
      break;
    case 7: // Shipped
      color = "lightseagreen";
      break;
    case 9: // Pending Images
      color = "#bb8e04";
      break;
    default:
      break;
  }

  return color;
};

export const getHeaders = (type = "") => {
  const ckObject = localStorage.getItem("ckAdminUser") || "{}";
  const data = JSON.parse(ckObject) || {};
  const { jwttoken = "" } = data;

  switch (type) {
    case "publicJson":
      return new Headers({
        "Content-Type": "application/json",
      });
    case "publicMultipart":
      return new Headers({
        "Content-Type": "multipart/formdata",
      });
    case "authorizeMultipart":
      return new Headers({
        Authorization: jwttoken,
        "Content-Type": "multipart/formdata",
      });
    case "authorizeJson":
      return new Headers({
        Authorization: jwttoken,
        "Content-Type": "application/json",
      });
    case "authorize":
      return new Headers({
        Authorization: jwttoken,
      });
    case "allowCorsAuthorize":
      return new Headers({
        Authorization: jwttoken,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
      });
    default:
      return new Headers({});
  }
};

export const formatBytes = (bytes) => {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const formatInternetEstTime = (seconds) => {
  const weeks = Math.floor(seconds / 604800); // 1 week = 604800 seconds
  const days = Math.floor((seconds % 604800) / 86400); // 1 day = 86400 seconds
  const hrs = Math.floor((seconds % 86400) / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  let formatTimeStr = "N/A";

  if (weeks > 0) {
    formatTimeStr = `${weeks}w ${days}d ${hrs}h ${mins}m ${secs}s`;
  } else if (days > 0) {
    formatTimeStr = `${days}d ${hrs}h ${mins}m ${secs}s`;
  } else if (hrs > 0) {
    formatTimeStr = `${hrs}h ${mins}m ${secs}s`;
  } else if (mins > 0) {
    formatTimeStr = `${mins}m ${secs}s`;
  } else {
    formatTimeStr = `${secs}s`;
  }
  return formatTimeStr;
};

export const getHeadersOld = (type = "") => {
  const ckObject = localStorage.getItem("ckAdminUser") || "{}";
  const data = JSON.parse(ckObject) || {};
  const { jwttoken = "" } = data;

  switch (type) {
    case "publicJson":
      return new Headers({
        "Content-Type": "application/json",
      });
    case "publicMultipart":
      return new Headers({
        "Content-Type": "multipart/formdata",
      });
    case "authorizeMultipart":
      return new Headers({
        Authorization: "Bearer " + jwttoken,
        "Content-Type": "multipart/formdata",
      });
    case "authorizeJson":
      return new Headers({
        Authorization: "Bearer " + jwttoken,
        "Content-Type": "application/json",
      });
    case "authorize":
      return new Headers({
        Authorization: "Bearer " + jwttoken,
      });
    case "allowCorsAuthorize":
      return new Headers({
        Authorization: "Bearer " + jwttoken,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Origin, X-Requested-With, Content-Type, Accept",
      });
    default:
      return new Headers({});
  }
};

export const getColorCodeByOrderStatus = (status = "0") => {
  let parseStatus = status ? parseInt(status) : 0;
  let colorCode = "#000000";
  switch (parseStatus) {
    case 1:
      colorCode = "#808080";
      break;
    case 2:
      colorCode = "#05e35e";
      break;
    case 3:
      colorCode = "#0591e3";
      break;
    case 4:
      colorCode = "#05e35e";
      break;
    case 5:
      colorCode = "#05e35e";
      break;
    case 6:
      colorCode = "#ff0000";
      break;
    case 7:
      colorCode = "#808080";
      break;
    case 8:
      colorCode = "#04b8a9";
      break;
    case 9:
      colorCode = "#ff7300";
      break;
    default:
      colorCode = "#000000";
  }

  return colorCode;
};

export const getColorCodeByOrderItemStatus = (status = "0") => {
  let parseStatus = status ? parseInt(status) : 0;
  let colorCode = "#000000";
  switch (parseStatus) {
    case 0:
    case 1:
      colorCode = "red";
      break;
    case 2:
      colorCode = "#3b85ff";
      break;
    case 3:
      colorCode = "green";
      break;
    default:
      colorCode = "#000000";
  }

  return colorCode;
};

const CACHE_NAME = "CK-REACT-CACHE-v1";

export async function setCacheBlobFile(blob, fileName) {
  let myResponse = {
    code: 0,
    msg: "Failed to cache custom file",
  };
  try {
    if (typeof caches == "undefined") {
      const errorMsg = "caches API is not supported in this environment.";
      console.error(errorMsg);
      myResponse.msg = errorMsg;
      return myResponse;
    }

    const cache = await caches.open(CACHE_NAME);
    const fileUrl = `/cached/${fileName}`;

    const response = new Response(blob);
    await cache.put(fileUrl, response);
    console.log(`Blob file cached successfully as: ${fileUrl}`);
    myResponse.code = 1;
    myResponse.msg = `Blob file cached successfully as: ${fileUrl}`;
    return myResponse;
  } catch (error) {
    console.error(`Failed to cache blob file: ${fileName}`, error);
    myResponse.code = 2;
    myResponse.msg = `Failed to cache blob file: ${fileName}`;
    return myResponse;
  }
}

export async function setCacheCustomFilePicker(file) {
  let myResponse = {
    code: 0,
    msg: "Failed to cache custom file",
  };

  if (typeof caches == "undefined") {
    const errorMsg = "caches API is not supported in this environment.";
    console.error(errorMsg);
    myResponse.msg = errorMsg;
    return myResponse;
  }

  try {
    const cache = await caches.open(CACHE_NAME);
    const fileUrl = `/cached/${file.name}`;
    const response = new Response(file);
    await cache.put(fileUrl, response);
    console.log(`Custom file cached successfully: ${file.name}`);
    myResponse.code = 1;
    myResponse.msg = `Custom file cached successfully: ${file.name}`;
    return myResponse;
  } catch (error) {
    console.error(`Failed to cache custom file: ${file.name}`, error);
    myResponse.code = 2;
    myResponse.msg = `Failed to cache custom file: ${file.name}`;
    return myResponse;
  }
}

export async function getCachedBlobFile(fileName) {
  let myResponse = {
    code: 0,
    msg: "Failed to cache custom file",
    blob: null,
  };
  try {
    if (typeof caches == "undefined") {
      const errorMsg = "caches API is not supported in this environment.";
      console.error(errorMsg);
      myResponse.msg = errorMsg;
      return myResponse;
    }

    const cache = await caches.open(CACHE_NAME);
    const fileUrl = `/cached/${fileName}`;

    const cachedResponse = await cache.match(fileUrl);

    if (cachedResponse) {
      const blob = await cachedResponse.blob();
      console.log(`Retrieved blob from cache: ${fileName}`);
      myResponse.code = 1;
      myResponse.blob = blob;
      myResponse.msg = `Retrieved blob from cache: ${fileName}`;
      return myResponse;
    } else {
      console.log(`Blob not found in cache: ${fileName}`);
      myResponse.code = 2;
      myResponse.blob = null;
      myResponse.msg = `Blob not found in cache: ${fileName}`;
      return myResponse;
    }
  } catch (error) {
    console.log(`Failed found in cache: ${fileName}`);
    myResponse.code = 3;
    myResponse.blob = null;
    myResponse.msg = `Failed found in cache: ${fileName}`;
    return myResponse;
  }
}

export async function clearAllCache() {
  let myResponse = {
    code: 0,
    msg: "Failed to cache custom file",
  };

  if (typeof caches == "undefined") {
    const errorMsg = "caches API is not supported in this environment.";
    console.error(errorMsg);
    myResponse.msg = errorMsg;
    return myResponse;
  }

  try {
    const isDeleted = await caches.delete(CACHE_NAME);

    if (isDeleted) {
      console.log(`All files deleted successfully from cache: ${CACHE_NAME}`);
      myResponse.msg = `All files deleted successfully from cache: ${CACHE_NAME}`;
    } else {
      console.log(`Cache not found: ${CACHE_NAME}`);
      myResponse.msg = `Cache not found: ${CACHE_NAME}`;
    }
    myResponse.code = 1;
    return myResponse;
  } catch (error) {
    console.error(`Failed to delete cache: ${CACHE_NAME}`, error);
    myResponse.code = 2;
    myResponse.msg = `Failed to delete cache: ${CACHE_NAME}`;
  }
}

export async function removeCachedFile(fileName) {
  let myResponse = {
    code: 0,
    msg: "Failed to cache custom file",
  };
  try {
    if (typeof caches == "undefined") {
      const errorMsg = "caches API is not supported in this environment.";
      console.error(errorMsg);
      myResponse.msg = errorMsg;
      return myResponse;
    }

    const cache = await caches.open(CACHE_NAME);
    const fileUrl = `/cached/${fileName}`;

    const isDeleted = await cache.delete(fileUrl);
    if (isDeleted) {
      console.log(`File deleted successfully from cache: ${fileName}`);
      myResponse.msg = `File deleted successfully from cache: ${fileName}`;
    } else {
      console.log(`File not found in cache: ${fileName}`);
      myResponse.msg = `File not found in cache: ${fileName}`;
    }
    myResponse.code = 1;
    return myResponse;
  } catch (error) {
    console.error(`Failed to delete file from cache: ${fileName}`, error);
    myResponse.code = 2;
    myResponse.msg = `Failed to delete file from cache: ${fileName}`;
  }
}
